import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { AutenticarService } from "./autenticar.service";
// tslint:disable-next-line:import-blacklist
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: "root",
})
export class Interceptor {
  constructor(
    private inyector: Injector,
    private router: Router,
    private modalService: NgbModal
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    /*  El código original con la inyección del AutenticacionService
           en el constructor fallabas. Así que siguiendo las instrucciones de:
           https://stackoverflow.com/questions/45654351/injector-error-provider-parse-errors-cannot-instantiate-cyclic-dependency
           https://github.com/angular/angular/issues/18224#issuecomment-316957213
           he tenido que hacer la  inyección manual con inyector
       */
    // Get the auth header from your auth service.
    const auth = this.inyector.get(AutenticarService);
    const actToken = auth.token;
    const authReq = req.clone({
      headers: req.headers.set("Authorization", `Token ${actToken}`),
    });
    //console.log(authReq);
    return next.handle(authReq).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Si no hay error, podemos añadir código
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              // Acceso no autorizado
              const modalRef = this.modalService.open(AvisosComponent);
              modalRef.componentInstance.datAviso = {
                tit: "ERROR SERVIDOR",
                tex: "(401) Carece de permiso o éste ha caducado",
                tip: 2,
                btcan: "",
                btno: "",
                btsi: "Aceptar",
              };
              modalRef.result.then((result) => {
                this.router.navigate(["/login"]);
              });
            } else {
              // Otros errores
              const modalRef = this.modalService.open(AvisosComponent);
              modalRef.componentInstance.datAviso = {
                tit: "ERROR SERVIDOR",
                tex: err.status + " " + err.statusText,
                tip: 2,
                btcan: "",
                btno: "",
                btsi: "Aceptar",
              };
              modalRef.result.then((result) => {
                this.router.navigate(["/portada"]);
              });
            }
          }
        }
      )
    );
  }
}
